jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    // *************************************************************************************************
    //	Footer Mobile Menu
    // *************************************************************************************************

    if ($(window).width() <= 768) {
            $('.linkWrapper__widgets .widget').on('click', function() {
                $(this).toggleClass('active').siblings().removeClass('active');
                $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
            });
        }

    // *************************************************************************************************
	//	Homepage Scripts
	// *************************************************************************************************

    if (document.body.classList.contains('home')) {

	    // *********************************************************************************************
		//	Scroll Reveal
		// *********************************************************************************************

	    $(window).bind("load", function() {

			//grab all elements that have the .ux-loading-item class
			var uxElements = $('.ux-loading-item');

			//run through the uxElements object array
			if (uxElements) {

				//run through the uxElements object array
				uxElements.each(function(index) {

					//make instances of each one - this
					var Element = $(this);

					// run a time out and add class of active and multiply the delay times the position it is in the object
					setTimeout(function() {
						Element.addClass('active');
					}, 500 * index);
				});
			}
		});

		var sr_elements = $('.fly-in-bottom, .fly-in-left, .fly-in-right, .fly-in-top');

		// if there are sr elements let's do them
		if (sr_elements) {
			window.sr = ScrollReveal({
				duration: 750,
				scale: 1,
				origin: 'bottom',
				distance: '100px',
				easing: 'ease'
			});

			// Model Section
			sr.reveal('.modelSection .wrapperRow, .modelSection .wrapperRow__button', 75);

			// CTA Section
			sr.reveal('.ctaSection > .container-wide', 75);

			// Content Section
			sr.reveal('.contentSection .contentSection__container', 75);

			// Direction Section
			sr.reveal('.directionHeader h3', 75);

			// Map Section
			sr.reveal('.mapSection .mapWrapper__directions', 75);

			// Seo Section
			sr.reveal('.seoSection .seoSection__content', 75);

		}

	    // *********************************************************************************************
		//	Homepage Select Scripts
		// *********************************************************************************************

		if ($(window).width() > 767) {

		    setTimeout(function() {
		        $("#homepage-advanced-search select").selectpicker({ dropupAuto: false });
		        $("body").live('search_filters_rendered', function() {
		            $("#homepage-advanced-search select").selectpicker('refresh');
		        });
		        $("#homepage-advanced-search .filters").fadeIn();
		    }, 600);
		}
		// END -> HOMEPAGE SELECTS

		// *********************************************************************************************
		//	Model Section Script
		// *********************************************************************************************

    	var models_slider = new Swiper('.modelSection .swiper-container', {
			speed: 300,
			slidesPerGroup: 3,
			slidesPerView: 3,
			spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
			watchOverflow: true,
			lazy: {
				enabled: true,
			},
			navigation: {
				nextEl: '.modelSection .swiper-button-next.model',
				prevEl: '.modelSection .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 2,
					slidesPerView: 2
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
		});

		$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
			var index = $(this).parent().index()
			if (models_slider && models_slider[index]) {
				models_slider[index].update();
				models_slider[index].navigation.update();
			}
			if (typeof LazyLoad === "function") {
				var myLazyLoad = new LazyLoad();
			}
		})

		if ($(window).width() <= 1024) {
			jQuery('#small-selects #modelTab-contents li a').click(function() {
				var title = jQuery(this).data('title');
				jQuery('#modelTab .swap').html(title);
			});
		}

		// Lazyload
		setTimeout(function() {
	        $(".modelSection .vehicle-box__image img").each(function() {
	            $(this).attr("src", $(this).attr("data-original"));
	        });
	    }, 3000);
		// END -> MODEL SECTION ITEMS
    }

});
